<script lang="ts">
  import { SearchState } from "../../services/search-service";
  import {
    deleteAllSearchQueryStringParameter,
    deleteSearchQueryStringParameter,
    setQueryStringParameter
  } from "../../url";
  import type { SearchStateModel } from "../../models/search.interface";
  import TooltipHybridButton from "./TooltipHybridButton.svelte";

  export let title = "";
  export let placeholder = "";
  export let tooltip = "Enter a search term to do a regular search.";
  export let urlparam: string;
  export let list = [];

  const id = title.replace(" ", "");

  let collectionSearchInput: string;
  let params = [];

  SearchState.subscribe((search: SearchStateModel) => {
    collectionSearchInput = search.params[urlparam] ? search.params[urlparam].join() : "";
    params = search.params.getAll(urlparam) ? search.params.getAll(urlparam) : [];
  });

  function setSearchParam() {
    collectionSearchInput !== null ? setQueryStringParameter(urlparam, collectionSearchInput, false)
            : deleteAllSearchQueryStringParameter(urlparam);
  }

</script>


<li class="mb-1">
  <div class="pb-2">
    {title}
    <TooltipHybridButton
            searchUrlQueryParam="{id}-search"
            tooltip={tooltip}
    />
    <!--    <i-->
    <!--        id="{id}ToolTip"-->
    <!--        class="bi bi-question-circle-fill"-->
    <!--        aria-label="{id} Search Tool Tip"-->
    <!--        aria-describedby="{id}SearchToolTipContent"-->
    <!--    ></i>-->
    <!--    <Tooltip id="{id}SearchToolTipContent" target="{id}ToolTip" placement="right" role="tooltip">-->
    <!--      <span>{tooltip}</span>-->
    <!--    </Tooltip>-->
  </div>
  <form>
    <div class="form-floating margin-2">
      <select class="form-select"
              bind:value={collectionSearchInput}
              on:change={()=> setSearchParam()}
              aria-label={tooltip}>
        <option value={null}>{placeholder}</option>
        {#each list as i}
          <option value={i}>{i}</option>
        {/each}
      </select>
      <label for="searchFloatingInput">{placeholder}</label>
    </div>
  </form>
  {#if $SearchState.params.has(urlparam)}
    {#each params as p, i}
      <div class="d-flex py-1">
        <span style="overflow-x: hidden; text-overflow: ellipsis"
              class="badge rounded-pill text-bg-dark pb-0 pe-3 pt-1"
              role="status"
              aria-label="name search pill: {p}"
        >
            <button type="button" class="btn p-0 m-0"
                    on:click={() => deleteSearchQueryStringParameter(urlparam, p)}
            >
                <i class="bi bi-x text-bg-dark" aria-label="Delete {p}"></i>
            </button>
          {p}
        </span>
      </div>
    {/each}
  {/if}
</li>
